export class FaqContent {

  constructor(fields) {
    this.fields = fields;
  }

  mapToStandard() {

    return {
      id: this.fields?.attributes?.id,
      title: this.fields?.attributes?.title,
      header: this.fields?.attributes?.field_header?.value,
      headerImage: this.getRelationshipValue('field_header_image'),
      faqs: this.fields?.attributes?.faqItems
    };
  }

  getRelationshipValue(field) {

    const rel = this.fields.attributes.relationships.find((i) => i.field === field);

    return rel
      ? rel.value
      : null;
  }
}
